import { render } from "./SalesPaymentReport.vue?vue&type=template&id=04bff090"
import script from "./SalesPaymentReport.vue?vue&type=script&lang=js"
export * from "./SalesPaymentReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__